import ReactSelect from "react-select";
import SelectStyles from "./selectStyle";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { parseCompetences } from "../../utils/Utils";

const InternalSelectors = ({
  grade,
  subject,
  competencesStore,
  data,
  selectedData,
}) => {
  const { t } = useTranslation();

  const displayTexts = {
    competencePlaceholder: t("competence_placeholder"),
    competenceLabel: t("competences"),

    capabilitiesPlaceholder: t("capabilities_placeholder"),
    capabilitiesLabel: t("capabilities"),

    performancePlaceholder: t("performance_placeholder"),
    performanceLabel: t("performances"),
  };

  const [competencesForDisplay, setCompetencesForDisplay] = useState([]);
  const [capabilitiesForDisplay, setCapabilitiesForDisplay] = useState([]);
  const [performancesForDisplay, setPerformancesForDisplay] = useState([]);

  const [currentCompetence, setCurrentCompetence] = useState(null);
  const [currentCapability, setCurrentCapability] = useState(null);
  const [currentPerformance, setCurrentPerformance] = useState(null);

  const mapItemToOption = useCallback(
    (item) => ({
      value: item,
      label: item,
    }),
    []
  );

  const updateValues = ({ competence, capability, performance }) => {
    const parsedData = parseCompetences({
      grade,
      subject,
      competence,
      capability,
      performance,
      data,
    });
    setCompetencesForDisplay(
      parsedData?.competences?.map((item) => mapItemToOption(item))
    );
    setCapabilitiesForDisplay(
      parsedData?.capabilities?.map((item) => mapItemToOption(item))
    );
    setPerformancesForDisplay(
      parsedData?.performances?.map((item) => mapItemToOption(item))
    );
  };

  useEffect(() => {
    if (data?.length) {
      setCurrentCompetence(null);
      setCurrentCapability(null);
      setCurrentPerformance(null);

      const parsedData = parseCompetences({ grade, subject, data });
      setCompetencesForDisplay(
        parsedData?.competences?.map((item) => mapItemToOption(item))
      );
      setCapabilitiesForDisplay(
        parsedData?.capabilities?.map((item) => mapItemToOption(item))
      );
      setPerformancesForDisplay(
        parsedData?.performances?.map((item) => mapItemToOption(item))
      );
    }

    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (subject) {
      setCurrentCompetence(null);
      setCurrentCapability(null);
      setCurrentPerformance(null);

      const parsedData = parseCompetences({ grade, subject, data });
      setCompetencesForDisplay(
        parsedData?.competences?.map((item) => mapItemToOption(item))
      );
      setCapabilitiesForDisplay(
        parsedData?.capabilities?.map((item) => mapItemToOption(item))
      );
      setPerformancesForDisplay(
        parsedData?.performances?.map((item) => mapItemToOption(item))
      );
    }

    // eslint-disable-next-line
  }, [subject]);

  useEffect(() => {
    if(currentCompetence && capabilitiesForDisplay.length){     
      setCurrentCapability(capabilitiesForDisplay[0].value);
      updateValues({ competence: currentCompetence, capability: capabilitiesForDisplay[0].value });
      competencesStore.addCapabilities(capabilitiesForDisplay[0].value);
    }
    // eslint-disable-next-line
  },[currentCompetence])

  useEffect(() => {
    // if (selectedData) {
    //   setCurrentCompetence(selectedData.competence);
    //   setCurrentCapability(selectedData.capabilities);
    //   // setCurrentPerformance(selectedData.performance);
    //   updateValues({
    //     competence: selectedData.competence,
    //     capability: selectedData.capabilities,
    //     performance: selectedData.performance,
    //   });
    // }
  }, [selectedData]);

  return (
    <>
      <div className="flex flex-col childs-w-full mt-4">
        <section className="flex-1 flex flex-col gap-2">
        <label className="input-label">
              {t("formulario_edas_campo_competencia_select_label")}
            </label>
            <label className="input-instruction !min-h-auto !pb-2">
              {t("formulario_edas_campo_placeholder_competencia")}
            </label>
          <ReactSelect
            options={competencesForDisplay}
            value={
              competencesForDisplay.find(
                (option) => option.value === currentCompetence
              ) || null
            }
            placeholder={displayTexts.competencePlaceholder}
            onChange={(option) => {
              const competence = option?.value;

              if (!competence) {
                competencesStore.removeCompetence(currentCompetence);
              }

              setCurrentCompetence(competence);
              updateValues({ competence });
              competencesStore.addCompetence(competence);
            }}
            styles={SelectStyles}
            isMulti={false}
            maxMenuHeight={400}
            menuPlacement="bottom"
            isClearable
          />
        </section>

        {
          currentCompetence && (
            <section className="flex-1 flex flex-col gap-2">
          <div className='mt-6 flex flex-col gap-2'>
            <label className="input-instruction !min-h-auto !pb-2">{t("modal_edas_texto_capacidades")}</label>
            <ul className='flex flex-col gap-2 px-4'>
              {
                capabilitiesForDisplay.map((e,i) =>  <li key={i} className='py-2 px-4 bg-LightBlue-500/10 text-Grey-50 text-sm rounded-2'>{e.label}</li>)
              }
             
            </ul>
          </div>


          {/* <ReactSelect
            options={capabilitiesForDisplay}
            value={
              capabilitiesForDisplay.find(
                (option) => option.value === currentCapability
              ) || null
            }
            placeholder={displayTexts.capabilitiesPlaceholder}
            onChange={(option) => {
              const competence = currentCompetence;
              const capability = option?.value;

              if (!capability) {
                competencesStore.removeCapabilities(currentCapability);
              }

              setCurrentCapability(capability);
              updateValues({ competence, capability });
              competencesStore.addCapabilities(capability);
            }}
            styles={SelectStyles}
            isMulti={false}
            maxMenuHeight={400}
            menuPlacement="bottom"
            isClearable
          /> */}

        </section>
          )
        }

        <section className="flex-1 flex flex-col gap-2">
        <label className="input-label">
              {t("formulario_edas_campo_desempeno_select_label")}
            </label>
            <label className="input-instruction !min-h-auto !pb-2">
              {t("formulario_edas_campo_placeholder_desempeno")}
            </label>
          <ReactSelect
            options={performancesForDisplay}
            value={
              performancesForDisplay.find(
                (option) => option.value === currentPerformance
              ) || null
            }
            placeholder={displayTexts.performancePlaceholder}
            onChange={(option) => {
              const competence = currentCompetence;
              const capability = currentCapability;
              const performance = option?.value;

              if (!performance) {
                competencesStore.removePerformance(currentPerformance);
              }
              const findCurrentCompetenteRegister = data.find(e => e.competence === competence && e.capability === capability && e.performance === performance);
              
              setCurrentPerformance(performance);
              updateValues({ competence, capability, performance });
              competencesStore.addPerformance(performance);
              if(findCurrentCompetenteRegister) {
                competencesStore.addCompetenceRegister(findCurrentCompetenteRegister);
              }
            }}
            styles={SelectStyles}
            isMulti={false}
            maxMenuHeight={400}
            menuPlacement="bottom"
            isClearable
          />
        </section>
      </div>
    </>
  );
};

export default InternalSelectors;
